// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"heroLayout_wrapper__nIl5l","container":"heroLayout_container__GlU4f","left":"heroLayout_left__D5SE5","right":"heroLayout_right__eYZ0Q","image":"heroLayout_image__2b8Le"};